export var a11y = { ariaLabelCloseButton: 'close' };
//# sourceMappingURL=strings.js.map